import React, { useEffect, useMemo, useState } from "react";
import "../styles/DashboardAdmin.css";
import "../styles/DashboardUsager.css";

import { PageRDVUsager, PageMesRDVUsager } from "./PageRDVUsager";
import { PageParametresUsager }           from "./PageParametresUsager";
import { API_BASE }                        from "../config";

/* ── Icônes SVG ─────────────────────────────────────────────────── */
const Icons = {
  overview: (
    <svg viewBox="0 0 24 24"><path d="M3 13h8V3H3v10zm10 8h8V11h-8v10zM3 21h8v-6H3v6zm10-18v6h8V3h-8z"/></svg>
  ),
  rdv: (
    <svg viewBox="0 0 24 24">
      <path d="M19 4h-1V2h-2v2H8V2H6v2H5C3.9 4 3 4.9 3 6v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>
      <path d="M7 11h4v4H7z"/>
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24">
      <path d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.49.49 0 0 0 .12-.64l-1.92-3.32a.49.49 0 0 0-.61-.22l-2.39.96c-.5-.38-1.03-.7-1.63-.94l-.36-2.54A.484.484 0 0 0 13.88 2h-3.76c-.24 0-.43.17-.47.42l-.36 2.54c-.6.24-1.16.56-1.63.94l-2.39-.96c-.23-.09-.49 0-.61.22L2.74 8.48c-.13.22-.07.49.12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.64.06.94l-2.03 1.58a.49.49 0 0 0-.12.64l1.92 3.32c.12.22.39.3.61.22l2.39-.96c.5.38 1.03.7 1.63.94l.36 2.54c.05.24.24.42.47.42h3.76c.24 0 .44-.17.47-.42l.36-2.54c.6-.24 1.16-.56 1.63-.94l2.39.96c.23.09.49 0 .61-.22l1.92-3.32c.12-.22.07-.49-.12-.64l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z"/>
    </svg>
  ),
  mesrdv: (
    <svg viewBox="0 0 24 24"><path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/></svg>
  ),
  logout: (
    <svg viewBox="0 0 24 24">
      <path d="M10 17l1.41-1.41L8.83 13H20v-2H8.83l2.58-2.59L10 7l-5 5 5 5zM4 4h6V2H4C2.9 2 2 2.9 2 4v16c0 1.1.9 2 2 2h6v-2H4V4z"/>
    </svg>
  ),
};

/* ── Dashboard principal ─────────────────────────────────────────── */
const DashboardUsager = ({ user, onLogout, onUpdateUser }) => {
  const menuItems = useMemo(() => [
    { key: "overview",  label: "Tableau de bord",       icon: Icons.overview  },
    { key: "rdv",       label: "Prise de rendez-vous",  icon: Icons.rdv       },
    { key: "mes-rdv",   label: "Mes rendez-vous",       icon: Icons.mesrdv    },
    { key: "settings",  label: "Paramètres du profil",  icon: Icons.settings  },
  ], []);

  const [active, setActive]           = useState("overview");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [confirmLogout, setConfirmLogout] = useState(false);

  const closeSidebar  = () => setSidebarOpen(false);
  const handleSelect  = (key) => { setActive(key); closeSidebar(); };
  const pageTitle     = (k) => menuItems.find(i => i.key === k)?.label || "Espace Usager";

  const nom = user?.nom_complet || user?.email || "Usager";

  return (
    <div className="adminApp">
      {/* ── Overlay mobile ── */}
      <button
        className={`adminOverlay ${sidebarOpen ? "isOpen" : ""}`}
        aria-label="Fermer le menu"
        onClick={closeSidebar}
      />

      {/* ── Sidebar ── */}
      <aside className={`adminSidebar ${sidebarOpen ? "isOpen" : ""}`}>

        {/* Marque */}
        <div className="adminBrand">
          <div className="adminLogo">FD</div>
          <div className="adminBrandText">
            <div className="adminBrandTitle">FormiDoc</div>
            <div className="adminBrandSub">Espace Usager</div>
          </div>
        </div>

        {/* Profil */}
        <div className="adminProfile">
          <div className="adminProfileTop">
            <div className="adminProfileLabel">Connecté en tant que</div>
            <span className="adminRolePill">Usager</span>
          </div>
          <div className="adminEmail">{user?.email}</div>
          {user?.nom_complet && (
            <div className="usagerNom">{user.nom_complet}</div>
          )}
        </div>

        {/* Navigation */}
        <nav className="adminNav">
          {menuItems.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`adminNavItem ${active === item.key ? "active" : ""}`}
              onClick={() => handleSelect(item.key)}
            >
              <span className="adminNavIcon">{item.icon}</span>
              <span className="adminNavText">{item.label}</span>
            </button>
          ))}
        </nav>

        {/* Déconnexion */}
        <div className="adminSidebarFooter">
          <button
            className="adminLogout"
            onClick={() => setConfirmLogout(true)}
          >
            <span className="adminLogoutIcon">{Icons.logout}</span>
            <span>Se déconnecter</span>
          </button>
        </div>
      </aside>

      {/* ── Modal confirmation déconnexion ── */}
      {confirmLogout && (
        <div className="logoutModalOverlay">
          <div className="logoutModal">
            <div className="logoutModalTitle">Déconnexion</div>
            <div className="logoutModalText">
              Voulez-vous vraiment vous déconnecter ?
            </div>
            <div className="logoutModalActions">
              <button
                className="btnSecondary"
                onClick={() => setConfirmLogout(false)}
              >
                Annuler
              </button>
              <button
                className="btnDanger"
                onClick={() => { setConfirmLogout(false); onLogout?.(); }}
              >
                Se déconnecter
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Contenu principal ── */}
      <main className="adminMain">
        <header className="adminTopbar">
          <div className="adminTopbarLeft">
            <button
              className="adminBurger"
              aria-label="Ouvrir le menu"
              onClick={() => setSidebarOpen(true)}
              type="button"
            >
              <span /><span /><span />
            </button>
            <div>
              <div className="adminTitle">{pageTitle(active)}</div>
            </div>
          </div>
        </header>

        <section className="adminContent">
          {active === "overview"  && <OverviewUsager nom={nom} onNavigate={handleSelect} user={user} />}
          {active === "rdv"       && <PageRDVUsager user={user} onNavigate={handleSelect} />}
          {active === "mes-rdv"   && <PageMesRDVUsager user={user} />}
          {active === "settings"  && <PageParametresUsager user={user} onUpdateUser={onUpdateUser} />}
        </section>
      </main>
    </div>
  );
};

/* ── Helpers ─────────────────────────────────────────────────────── */
const STATUT_LABEL = { CONFIRME: "Confirmé", ANNULE: "Annulé", PASSE: "Passé", EN_ATTENTE: "En attente" };
const STATUT_COLOR = { CONFIRME: "#065f46", ANNULE: "#991b1b", PASSE: "#374151", EN_ATTENTE: "#92400e" };
const STATUT_BG    = { CONFIRME: "#d1fae5", ANNULE: "#fee2e2", PASSE: "#f1f5f9", EN_ATTENTE: "#fef3c7" };

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("fr-FR", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
}
function fmtDateShort(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("fr-FR", { day: "2-digit", month: "long" });
}
function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
}

/* ── Page : Tableau de bord (accueil) ───────────────────────────── */
const OverviewUsager = ({ nom, onNavigate, user }) => {
  const [rdvs, setRdvs]     = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user?.token) { setLoading(false); return; }
    fetch(`${API_BASE}/usager/rdv`, {
      headers: { Authorization: `Bearer ${user.token}` },
    })
      .then(r => r.ok ? r.json() : { items: [] })
      .then(d => setRdvs(d.items || []))
      .catch(() => setRdvs([]))
      .finally(() => setLoading(false));
  }, [user?.token]);

  const now = new Date();
  const upcoming  = rdvs
    .filter(r => r.statut === "CONFIRME" && new Date(r.debut) > now)
    .sort((a, b) => new Date(a.debut) - new Date(b.debut));
  const passed    = rdvs.filter(r =>
    r.statut === "PASSE" || (r.statut === "CONFIRME" && new Date(r.debut) <= now)
  );
  const cancelled = rdvs.filter(r => r.statut === "ANNULE");
  const nextRdv   = upcoming[0] || null;
  const recent    = [...rdvs].sort((a, b) => new Date(b.debut) - new Date(a.debut)).slice(0, 5);

  return (
    <div className="uOverview">

      {/* ── Bannière ── */}
      <div className="uWelcomeBanner">
        <div className="uWelcomeLeft">
          <div className="uWelcomeWave">👋</div>
          <div>
            <h1 className="uWelcomeTitle">
              Bonjour, <span className="uWelcomeName">{nom}</span>
            </h1>
            <p className="uWelcomeSub">Bienvenue dans votre espace personnel FormiDoc.</p>
          </div>
        </div>
        <button className="uWelcomeCta" onClick={() => onNavigate("rdv")}>
          + Nouveau RDV
        </button>
      </div>

      {/* ── KPI ── */}
      <div className="uStatsRow">
        <div className="uStatCard">
          <div className="uStatValue">{loading ? "—" : rdvs.length}</div>
          <div className="uStatLabel">Total RDV</div>
        </div>
        <div className="uStatCard uStatCardGreen">
          <div className="uStatValue">{loading ? "—" : upcoming.length}</div>
          <div className="uStatLabel">À venir</div>
        </div>
        <div className="uStatCard">
          <div className="uStatValue">{loading ? "—" : passed.length}</div>
          <div className="uStatLabel">Passés</div>
        </div>
        <div className="uStatCard uStatCardRed">
          <div className="uStatValue">{loading ? "—" : cancelled.length}</div>
          <div className="uStatLabel">Annulés</div>
        </div>
      </div>

      {/* ── Ligne principale ── */}
      <div className="uDashRow">

        {/* Prochain RDV */}
        <div className="uDashCard">
          <div className="uDashCardHeader">
            <span className="uDashCardTitle">Prochain rendez-vous</span>
            <button className="uDashCardLink" onClick={() => onNavigate("mes-rdv")}>Voir tout →</button>
          </div>
          {loading ? (
            <div className="uDashLoading">Chargement…</div>
          ) : nextRdv ? (
            <div className="uNextRdvBody">
              <div className="uNextRdvDateBox">
                <div className="uNextRdvDay">{fmtDateShort(nextRdv.debut)}</div>
                <div className="uNextRdvTime">{fmtTime(nextRdv.debut)}</div>
              </div>
              <div className="uNextRdvInfo">
                <div className="uNextRdvDoctor">{nextRdv.medecin_nom}</div>
                <div className="uNextRdvSpec">{nextRdv.medecin_specialite}</div>
                <div className="uNextRdvMotif">{nextRdv.motif_libelle}</div>
                {nextRdv.medecin_adresse && (
                  <div className="uNextRdvAddr">📍 {nextRdv.medecin_adresse}</div>
                )}
                <div className="uNextRdvRef">{nextRdv.reference}</div>
              </div>
            </div>
          ) : (
            <div className="uEmptyHint">
              <div className="uEmptyHintIcon">📅</div>
              <div className="uEmptyHintText">Aucun rendez-vous à venir</div>
              <button className="uEmptyHintCta" onClick={() => onNavigate("rdv")}>
                Prendre un RDV
              </button>
            </div>
          )}
        </div>

        {/* Activité récente */}
        <div className="uDashCard">
          <div className="uDashCardHeader">
            <span className="uDashCardTitle">Activité récente</span>
            <button className="uDashCardLink" onClick={() => onNavigate("mes-rdv")}>Voir tout →</button>
          </div>
          {loading ? (
            <div className="uDashLoading">Chargement…</div>
          ) : recent.length === 0 ? (
            <div className="uEmptyHint">
              <div className="uEmptyHintIcon">🗓</div>
              <div className="uEmptyHintText">Aucun rendez-vous</div>
            </div>
          ) : (
            <ul className="uRdvList">
              {recent.map(rv => (
                <li key={rv.id} className="uRdvItem">
                  <div className="uRdvItemLeft">
                    <div className="uRdvItemDoctor">{rv.medecin_nom}</div>
                    <div className="uRdvItemMotif">{rv.motif_libelle}</div>
                    <div className="uRdvItemDate">{fmtDate(rv.debut)} · {fmtTime(rv.debut)}</div>
                  </div>
                  <span
                    className="uRdvItemStatus"
                    style={{ background: STATUT_BG[rv.statut], color: STATUT_COLOR[rv.statut] }}
                  >
                    {STATUT_LABEL[rv.statut] || rv.statut}
                  </span>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* ── Actions rapides ── */}
      <div className="uQuickCards">
        <button className="uQuickCard" onClick={() => onNavigate("rdv")}>
          <div className="uQuickIcon uQuickIconGreen">
            <svg viewBox="0 0 24 24">
              <path d="M19 4h-1V2h-2v2H8V2H6v2H5C3.9 4 3 4.9 3 6v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/>
              <path d="M7 11h4v4H7z"/>
            </svg>
          </div>
          <div className="uQuickLabel">Prendre un rendez-vous</div>
          <div className="uQuickArrow">→</div>
        </button>

        <button className="uQuickCard" onClick={() => onNavigate("mes-rdv")}>
          <div className="uQuickIcon uQuickIconOrange">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"/>
            </svg>
          </div>
          <div className="uQuickLabel">Mes rendez-vous</div>
          <div className="uQuickArrow">→</div>
        </button>

        <button className="uQuickCard" onClick={() => onNavigate("settings")}>
          <div className="uQuickIcon uQuickIconBlue">
            <svg viewBox="0 0 24 24">
              <path d="M12 12a4 4 0 1 0-4-4 4 4 0 0 0 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
          </div>
          <div className="uQuickLabel">Modifier mon profil</div>
          <div className="uQuickArrow">→</div>
        </button>
      </div>

    </div>
  );
};

export default DashboardUsager;
